var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgListFilm = function SvgListFilm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 1000 1000",
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.0034,958.07c-252.4211,0-457.784-205.363-457.784-457.784s205.363-457.784,457.784-457.784 s457.7773,205.3629,457.7773,457.784S752.4244,958.07,500.0034,958.07z M500.0034,84.1686 c-229.4447,0-416.1173,186.6726-416.1173,416.1173s186.6726,416.1173,416.1173,416.1173S916.114,729.7307,916.114,500.286 S729.4481,84.1686,500.0034,84.1686z M407.1554,682.0351V317.9604l256.8902,182.0407L407.1554,682.0351z M448.822,398.554v202.8876 l143.1614-101.4404L448.822,398.554z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListFilm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list-film.f27cfcdf.svg";
export { ForwardRef as ReactComponent };